<template>
    <div id="app">
        <treeselect v-model="values" :multiple="multiple" :options="options || []" @input="getValue" placeholder="请选择"
            :normalizer="normalizer" />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    components: { Treeselect },
    data() {
        return {
            values: null
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [Array, String, Number],
            default: ""
        },
        options: {
            type: [Array, String],
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: false
        },
    },

    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        getValue(data) {
            if (this.multiple) {
                this.$emit('input', data.join(','));
            } else {
                this.$emit('input', data);
            };
        },
        setValue() {
            if (!this.$isblank(this.value)) {
                if (this.multiple) {
                    this.values = this.value.split(',');
                } else {
                    this.values = this.value;
                };
            };
        },
        normalizer(node) {
            return {
                label: node.title
            }
        },
    }
}
</script>
